"use strict";

module.exports = function (accumulator, order, product, component) {
  var addition = component.note || '';

  if (accumulator.length && addition.length) {
    return "".concat(accumulator, "\n").concat(addition);
  }

  return "".concat(accumulator).concat(addition);
};